import httpClient from '@/api/httpClient';

const save = configurationData => {
    return httpClient.post('configuration-data', configurationData)
        .then(({ data }) => data);
};

const saveAndSendEmail = configurationDataWithEmailAddress => {
    return httpClient.post('configuration-data/email', configurationDataWithEmailAddress)
        .then(({ data }) => data);
};

export default {
    save,
    saveAndSendEmail,
};
